module.exports = __webpack_public_path__ + "img/activeSet6.745fe752.png";